import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminLayout from '@/components/layout/AdminLayout';
import CareDashboard from '@/components/CareDashboard';
import { useAuth, API } from '@/App';
import axios from 'axios';

export default function ImpersonateView() {
  const { subscriberId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (subscriberId) {
      axios.post(`${API}/admin/impersonate/${subscriberId}`).catch(() => {});
    }
  }, [subscriberId]);

  const handleExit = async () => {
    try {
      await axios.post(`${API}/admin/impersonate/${subscriberId}/end`);
    } catch (e) { /* ignore */ }
    navigate('/admin/users');
  };

  return (
    <div className="min-h-screen bg-[#0B0F19]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <CareDashboard subscriberId={subscriberId} viewerRole="subscriber" readOnly={true} onExit={handleExit} />
      </div>
    </div>
  );
}
